import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { LogIn, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PORTAL_TOKEN_KEY = "boe_portal_token";

const formatError = (detail, fallback) => {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return fallback;
};

const MemberLoginModal = ({ open, onOpenChange }) => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/portal/login`, { name: name.trim(), password });
      localStorage.setItem(PORTAL_TOKEN_KEY, data.token);
      onOpenChange(false);
      navigate("/portal");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail, "Anmeldung fehlgeschlagen."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-anthracite-soft border border-gold/20 text-cream sm:max-w-sm" data-testid="member-login-modal">
        <DialogHeader>
          <div className="flex items-center justify-center w-12 h-12 rounded-full border border-gold/40 mx-auto" style={{ background: "rgba(198,156,34,0.1)" }}>
            <LogIn size={20} style={{ color: "#E5C76B" }} />
          </div>
          <DialogTitle className="text-cream text-center text-2xl mt-3">Mitglieder-Login</DialogTitle>
          <DialogDescription className="text-cream/55 text-center text-sm">
            Melde dich mit deinem Namen und Passwort an.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2" data-testid="member-login-form">
          <label className="flex flex-col gap-1.5">
            <span className="text-xs uppercase tracking-[0.18em] font-semibold text-cream/55">Name</span>
            <Input value={name} onChange={(e) => setName(e.target.value)} required autoFocus data-testid="member-login-name"
              className="h-12 rounded-xl bg-white/5 border-white/15 text-cream placeholder:text-cream/40 focus-visible:ring-gold/40 focus-visible:border-gold/60" />
          </label>
          <label className="flex flex-col gap-1.5">
            <span className="text-xs uppercase tracking-[0.18em] font-semibold text-cream/55">Passwort</span>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="member-login-password"
              className="h-12 rounded-xl bg-white/5 border-white/15 text-cream placeholder:text-cream/40 focus-visible:ring-gold/40 focus-visible:border-gold/60" />
          </label>
          <button type="submit" disabled={loading} data-testid="member-login-submit" className="btn-primary w-full disabled:opacity-70">
            {loading ? <><Loader2 size={18} className="animate-spin" /> Anmelden…</> : "Anmelden"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default MemberLoginModal;
